// extracted by mini-css-extract-plugin
export default {"button":"expand-button_button__s6f1o"};